import { useContext } from 'react';
import { SideBarOpenedContext, toggleSidebarFunction } from '../../store/sideBarOpened.context';

export function useSideBarOpened(): [boolean, toggleSidebarFunction] | null[] {
  return useContext(SideBarOpenedContext);
}
